import React, { useContext } from 'react';
import { TimeAgo } from './TimeAgo';
import { WSContext } from '../contexts/WSContext';
import Imagez from '../lib/reusable/Imagez';
import config from '../utils/config';
import { AuthContext } from '../reducers/Auth/AuthContext';
import { EventsStoreContext } from '../reducers/Events/EventsContext';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';

const CallCardProduct = (props) => {
  const { event } = props;
  const { WSConnection } = useContext(WSContext);
  const [authState] = useContext(AuthContext);
  const [, dispatch] = useContext(EventsStoreContext);
  const [placeState] = useContext(PlaceStoreContext);

  const {
    products: { productId__product },
  } = placeState;

  const {
    user: { placeId, alias: assignee },
  } = authState;

  const { userId, pointId, createdAt, details } = event;

  const imageUrl = `${config.uri.bucket}/${placeId}/high/${
    details.productId
  }.jpg?time=${new Date().getTime()}`;

  const confirmCall = async () => {
    try {
      const message = { type: 'CALL_CONFIRMED', payload: { userId, placeId, pointId, assignee } };
      const callCompleteMessage = JSON.stringify(message);
      await WSConnection.send(callCompleteMessage);
      await dispatch({ type: 'CALL_COMPTETED', payload: { pointId, assignee } });
    } catch (error) {
      console.error('ERROR', error);
    }
  };

  const productAvailable = productId__product?.[details.productId] !== undefined
  const confirm = productAvailable ? productId__product?.[details.productId]?.name.toUpperCase() : 'CONFIRM';

  return (
    <div className="p-rel f-c f-dirc f-jcsb m-4 W100 br-2 fds-3 oflowh">
      <div className="p-rel f-c" style={{ height: 128 }}>
        <Imagez
          className="H100"
          br="2px 2px 0px 0px"
          image={imageUrl}
          style={{ margin: 0, padding: 0, maxHeight: 128, transform: 'translateX(-33%)' }}
        />
        <div className="p-abs p-full f-c bg-yellow-l-0 l-1" style={{ height: 128 }} />
        <div className="p-abs p-full f-c f-dirc f-jcsb H100 l-2">
          <div className="f-c f-jcsb">
            <h1 className="f3b mp0 f40 ta-r f-1 mr-8 txt-black">{pointId}</h1>
          </div>
          <div className="f-c pc-lr pb-4">
            <TimeAgo className="f3b f08 ta-r f-1 txt-black" date={createdAt} />
          </div>
        </div>
      </div>
      <button
        className="f3b f10 pt-16 pb-16 W100 bg-info txt-white br-2 f-ls0"
        onClick={confirmCall}
      >
        {confirm}
      </button>
    </div>
  );
};

export { CallCardProduct };
